import React from 'react';
import { Box, TableRow, TableCell, CircularProgress } from '@mui/material';

export default function Loading({ colSpan }) {
  return colSpan ? (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ borderBottom: 'none' }}>
        <Box textAlign="center">
          <CircularProgress disableShrink className="primary-loader" />
        </Box>
      </TableCell>
    </TableRow>
  ) : (
    <div className="lazy-loading-component">
      <CircularProgress disableShrink className="primary-loader" style={{ margin: 'auto' }} />
    </div>
  );
}
